/** Total selected rows: «Всего строк: N» or «Всего строк: selected/total». */
export function formatTableRowCounterText(
  total: string | number,
  selectedCount?: number | null,
): string | null {
  if (selectedCount === undefined || selectedCount === null) return null
  const totalText = String(total)
  if (selectedCount > 0) return `Всего строк: ${selectedCount}/${totalText}`
  return `Всего строк: ${totalText}`
}
